import React, { useEffect, useState, useRef, useContext } from "react";
import styled from "styled-components";
import Titulo from "../../globals/Title";
import { showAlert } from "../../globals/Message";
import Header from "./Header";
import Graph from "./Graph";
import Toolbar from "./Toolbar";
import DetalleAccions from "./DetalleAccions";
import Grid from "./Grid";
import CSVExport from "./CSVExport";
import { Row, Col } from "react-bootstrap";
import { apiDate, ObtnerSemanaAnterior } from "../../../helpers/Date";
import Loader from "../../globals/Loader";
import { apiCall } from "../../../helpers/ApiCalls";
import Switch from "../../globals/Switch";
import "../../../assets/bootstrap/css/bootstrap.min.css";
import { SesionContext } from "../../../context/SesionContext";
import * as colors from "../../../constants/colors";
import { CsvVenta } from "../../../helpers/CsvVenta";
import "./style.scss";
/** Estilos Contenedores */
const Wrapper = styled.div`
  width: 100%;
  overflow-y: hidden;
`;

const GraphContainer = styled(Row)`
  margin: 8px 0;
  background-color: ${colors.blanco};
  padding: 8px 8px 0;
  height: ${(props) => (props.ready === "true" ? "auto" : "345px")};
  display: flex;
  align-items: center;
`;
const GridContainer = styled(Row)`
  height: 100%;
  margin: 0;
  padding: 0;
  position: relative;
`;
const ColStyle = styled(Col)`
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: ${(props) => props.align};
  align-items: center;
`;

/**Configuraciones */
const fechasIniciales = ObtnerSemanaAnterior();
function Reporte(props) {
  /**ESTADOS */

  const firstDate = fechasIniciales.firstDate;
  const secondDate = fechasIniciales.secondDate;

  const [ready, setReady] = useState(false);
  const [graphReady, setGraphReady] = useState(true);
  const [gridReady, setGridReady] = useState(true);
  const [dataGrid, setDataGrid] = useState([]);
  const [dataGraph, setDataGraph] = useState([]);
  const [dataTotales, setDataTotales] = useState({});
  const [fechaActualizacion, setFechaActualizacion] = useState("");
  const [dataCSV, setDataCSV] = useState([]);

  const [actualDateRange, setActualDateRange] = useState([
    apiDate(firstDate),
    apiDate(secondDate),
  ]);
  const [comparar, setComparar] = useState(true);
  const [dateRangeCompare, setDateRangeCompare] = useState([
    firstDate,
    secondDate,
  ]);
  const [dataComparar, setDataComparar] = useState([]);

  const [actualGraphTiempo, setActualGraphTiempo] = useState("dia");
  const [actualGridConcepto, setActualGridConcepto] = useState("upc");
  const [showGraph, setShowGraph] = useState(false);
  const [filtro, setFiltro] = useState({}); //este depende de los datos de la tabla
  const selectedRows = useRef([]);
  const concepto = useRef(actualGridConcepto);
  const tiempo = useRef(actualGraphTiempo);
  const [selectedRowsString, setSelectedRowsString] = useState("");
  const [selectedRowsRecord, setSelectedRowsRecord] = useState("");
  const [showDetalleOptions, setShowDetalleOptions] = useState({
    ver: false,
    regresar: false,
  });
  const [isDetalle, setIsDetalle] = useState(false);
  const [isDetalleHistorico, setIsDetalleHistorico] = useState(false);
  const [exportGrid, setExportGrid] = useState(false);
  const [dbcDetalle, setDbcDetalle] = useState(false);
  const [estadoSwitch, setEstadoSwitch] = useState(false);
  const [emptyFirst, setEmptyFirst] = useState(true);
  const { cerrarSesion } = useContext(SesionContext);

  /** Funciones */
  //Obtnemos datos iniciales
  function iniciarReporte(result) {
    if (result.success) {
      setEmptyFirst(false);
      setFechaActualizacion(result.data.fecha_actualizacion);
      setDataGraph(result.data.graph);
      setDataTotales(result.data.totales);

      setDataGrid(result.data.grid);
      setDataCSV(generarData(result.data.grid));
      setReady(true);
    } else {
      if (result.code === 401) {
        showAlert("La sesión caducó, por favor ingresa de nuevo");
        cerrarSesion();
      } else {
        if (result.code === 503) {
          showAlert("Estamos en mantenimiento intenta ingresar más tarde");
          cerrarSesion();
        } else {
          showAlert(
            "No se encontro información en este perido de los elementos seleccionados"
          );
          setReady(true);
          setEmptyFirst(false);
        }
      }
    }
  }

  //usamos el efecto vacio para hacer la invocacion en cuanto se llame le vista
  useEffect(() => {
    const params = {
      fecha_inicio: actualDateRange[0],
      fecha_fin: actualDateRange[1],
      grupo_concepto: "upc",
      grupo_tiempo: "dia",
      ocultar_nulos: 1,
    };
    apiCall("POST", "reporte/ventas", params).then((res) => {
      iniciarReporte(res);
    });
  }, []);

  //Api cada que cambia el tiempo
  useEffect(() => {
    if (!emptyFirst) {
      let params = {
        fecha_inicio: actualDateRange[0],
        fecha_fin: actualDateRange[1],
        grupo_concepto: actualGridConcepto,
        grupo_tiempo: actualGraphTiempo,
        only: "graph",
      };
      let endpoint = "reporte/ventas";
      if (!estadoSwitch) {
        params = Object.assign(params, { ocultar_nulos: 1 });
      }
      if (isDetalle) {
        params = Object.assign(params, { lista: selectedRowsRecord });
        endpoint = "reporte/ventasDetalle";
      }
      setGraphReady(false);
      setGridReady(false);
      apiCall("POST", endpoint, params).then((res) => {
        if (res.success) {
          tiempo.current = actualGraphTiempo;
          setFechaActualizacion(res.data.fecha_actualizacion);
          setDataGraph(res.data.graph);
          console.log("info graph", res.data.graph);
          setGraphReady(true);
          setGridReady(true);
        } else {
          if (res.code === 401) {
            showAlert("La sesión caducó, por favor ingresa de nuevo");
            cerrarSesion();
          } else {
            if (res.code === 503) {
              showAlert("Estamos en mantenimiento intenta ingresar más tarde");
              cerrarSesion();
            } else {
              showAlert(
                "No se encontro información en este perido de los elementos seleccionados"
              );
              setDataGraph([]);
              setGraphReady(true);
            }
          }
        }
      });
    }
  }, [actualGraphTiempo]);
  //Api cada que cambia el concepto
  useEffect(() => {
    if (!emptyFirst) {
      let params = {
        fecha_inicio: actualDateRange[0],
        fecha_fin: actualDateRange[1],
        grupo_concepto: actualGridConcepto,
        grupo_tiempo: actualGraphTiempo,
        only: "grid",
      };
      if (!estadoSwitch) {
        params = Object.assign(params, { ocultar_nulos: 1 });
      }
      setGridReady(false);
      setShowDetalleOptions({ ver: false, regresar: false });
      apiCall("POST", "reporte/ventas", params).then((res) => {
        if (res.success) {
          concepto.current = actualGridConcepto;
          setDataTotales(res.data.totales);
          setFechaActualizacion(res.data.fecha_actualizacion);
          setDataGrid(res.data.grid);
          console.log("info grid", res.data.grid);
          setDataCSV(generarData(res.data.grid));
          setGridReady(true);
        } else {
          if (res.code === 401) {
            showAlert("La sesión caducó, por favor ingresa de nuevo");
            cerrarSesion();
          } else {
            if (res.code === 503) {
              showAlert("Estamos en mantenimiento intenta ingresar más tarde");
              cerrarSesion();
            } else {
              showAlert(
                "No se encontro información en este perido de los elementos seleccionados"
              );
              concepto.current = actualGridConcepto;
              setDataTotales(0);
              setDataGrid([]);
              setDataCSV([]);
              setGridReady(true);
            }
          }
        }
      });
    }
  }, [actualGridConcepto]);
  //Api cada que cambia el rango de tiempo
  useEffect(() => {
    if (!emptyFirst) {
      let params = {
        fecha_inicio: actualDateRange[0],
        fecha_fin: actualDateRange[1],
        grupo_concepto: actualGridConcepto,
        grupo_tiempo: actualGraphTiempo,
      };
      let endpoint = "reporte/ventas";
      if (!estadoSwitch) {
        params = Object.assign(params, { ocultar_nulos: 1 });
      }
      if (comparar) {
        params = {
          ...params,
          compare: {
            fecha_inicio: dateRangeCompare[0],
            fecha_fin: dateRangeCompare[1],
          },
        };
      }
      if (isDetalle) {
        params = Object.assign(params, { lista: selectedRowsRecord });
        setShowDetalleOptions({ ver: false, regresar: false });
        endpoint = "reporte/ventasDetalle";
      }
      setGraphReady(false);
      setGridReady(false);
      apiCall("POST", endpoint, params).then((res) => {
        if (res.success) {
          tiempo.current = actualGraphTiempo;
          concepto.current = actualGridConcepto;
          setDataGraph(res.data.graph);
          setFechaActualizacion(res.data.fecha_actualizacion);
          setDataTotales(res.data.totales ?? {});
          setDataGrid(res.data.grid);
          setDataCSV(
            isDetalle
              ? generarDataDetalle(res.data.grid)
              : generarData(res.data.grid)
          );
          if (comparar) {
            setDataComparar(res.data.graph_comparar);
          }
          setTimeout(() => {
            setGraphReady(true);
            setGridReady(true);
          }, 100);
        } else {
          if (res.code === 401) {
            showAlert("La sesión caducó, por favor ingresa de nuevo");
            cerrarSesion();
          } else {
            if (res.code === 503) {
              showAlert("Estamos en mantenimiento intenta ingresar más tarde");
              cerrarSesion();
            } else {
              if (isDetalle) {
                showAlert(
                  "No se encontro información en este perido de los elementos seleccionados, se mostrará el historico."
                );
                verDetalleHistorico();
                setDataCSV([]);
              } else {
                showAlert(
                  "No se encontro información en este perido de los elementos seleccionados"
                );
                setDataGraph([]);
                setDataGrid([]);
                setDataCSV([]);
                setGraphReady(true);
                setGridReady(true);
              }
            }
          }
        }
      });
    }
  }, [actualDateRange]);
  //escuchamos cuando cambian el switch
  useEffect(() => {
    if (!emptyFirst) {
      toogleMostrarTodo();
    }
  }, [estadoSwitch]);

  //escuchamos cada que cmabie el rango de fecha (podemos usar efectos pero no logro resolverlo)
  function toogleDateRangeCompare(dateRange) {
    setDateRangeCompare([dateRange[0], dateRange[1]]);
  }
  function toogleDateRange(dateRange) {
    setActualDateRange([dateRange[0], dateRange[1]]);
  }
  //mostramops u ocultamos el grafico
  function toogleSwitch() {
    setShowGraph(!showGraph);
  }
  //obtenemos los lista con los indicadores del filtro
  function obtenerLista(selected) {
    let filtroID = actualGridConcepto;
    let filtro = actualGridConcepto;
    if (filtroID === "publisher") {
      filtroID = "id_publisher";
    }
    if (selected && selected.length > 0) {
      let lista = [];
      selected.forEach((item) => {
        lista.push({
          id: item.row[filtroID],
          value: item.row[filtro],
          nombre: item.row.nombre ?? "",
          plataforma: item.row.plataforma ?? "",
          no_factura: item.row.no_factura ?? "",
          //valid es para saber si podemos ver el detalle
          valid: item.row.unidades_periodo === "0" ? false : true,
        });
      });
      return lista;
    }
    return [];
  }
  async function toogleSelectedRows(selected) {
    selectedRows.current = obtenerLista(selected);

    if (selectedRows.current.length > 0) {
      setShowDetalleOptions({ ver: true, regresar: false });
    } else {
      setShowDetalleOptions({ ver: false, regresar: false });
    }
  }
  function validarLista(rows) {
    let valida = false;
    for (let index = 0; index < rows.length; index++) {
      if (rows[index].valid) {
        valida = true;
        break;
      }
    }
    return valida;
  }
  //ver rows
  async function verDetalle() {
    setShowDetalleOptions({ ver: false, regresar: true });
    const actualSelectedRows = selectedRows.current;
    let lista = ""; //talves puedo cambiarlo a un estado o ref
    try {
      if (actualSelectedRows && actualSelectedRows.length === 1) {
        setSelectedRowsString(actualSelectedRows[0].value);
        lista = actualSelectedRows[0].id;
      } else {
        if (actualSelectedRows.length > 2) {
          setSelectedRowsString(
            actualSelectedRows[0].value +
              "," +
              actualSelectedRows[1].value +
              "..."
          );
          actualSelectedRows.forEach((item, index) => {
            if (index === 0) {
              lista = item.id;
            }
            lista = lista + "," + item.id;
          });
        } else {
          setSelectedRowsString(
            actualSelectedRows[0].value + "," + actualSelectedRows[1].value
          );
          lista = actualSelectedRows[0].id + "," + actualSelectedRows[1].id;
        }
      }
    } catch (error) {
      lista = [];
    }
    if (lista.length > 0) {
      /**
       * Antes de ver el detalle vemos si la lista es valida
       * Si al menos un elemento es valido vemos el detalle
       * Si la lista es completamente invalida, consultamos el historico
       */
      if (validarLista(actualSelectedRows)) {
        //llamamos a la API de detalle
        setSelectedRowsRecord(lista);
        setGridReady(false);
        setGraphReady(false);
        await apiCall("POST", "reporte/ventasDetalle", {
          fecha_inicio: actualDateRange[0],
          fecha_fin: actualDateRange[1],
          grupo_concepto: concepto.current,
          grupo_tiempo: tiempo.current,
          lista: lista,
        }).then((res) => {
          if (res.success) {
            setIsDetalle(true);
            setDataGraph(res.data.graph);
            setDataTotales({});
            setDataGrid(res.data.grid);
            setDataCSV(generarDataDetalle(res.data.grid));
            setGraphReady(true);
            setGridReady(true);
          } else {
            if (res.code === 401) {
              showAlert("La sesión caducó, por favor ingresa de nuevo");
              cerrarSesion();
            } else {
              if (res.code === 503) {
                showAlert(
                  "Estamos en mantenimiento intenta ingresar más tarde"
                );
                cerrarSesion();
              } else {
                showAlert(
                  "No se encontro información en este perido de los elementos seleccionados"
                );
                setGraphReady(true);
                setGridReady(true);
                setDataCSV([]);
              }
            }
          }
        });
      } else {
        showAlert(
          "No se encontro información en este perido de los elementos seleccionados, se mostrará el historico."
        );
        //llamamos a la API de detalle historico
        setSelectedRowsRecord(lista);
        setGridReady(false);
        setGraphReady(false);
        await apiCall("POST", "reporte/ventasDetalle", {
          fecha_inicio: "2019-01-01",
          fecha_fin: actualDateRange[1],
          grupo_concepto: concepto.current,
          grupo_tiempo: tiempo.current,
          lista: lista,
        }).then((res) => {
          if (res.success) {
            setIsDetalleHistorico(true);
            setIsDetalle(true);
            setFechaActualizacion(res.data.fecha_actualizacion);
            setDataGraph(res.data.graph);
            setDataTotales({});
            setDataGrid(res.data.grid);
            setDataCSV(generarDataDetalle(res.data.grid));
            setGraphReady(true);
            setGridReady(true);
          } else {
            if (res.code === 401) {
              showAlert("La sesión caducó, por favor ingresa de nuevo");
              cerrarSesion();
            } else {
              if (res.code === 503) {
                showAlert(
                  "Estamos en mantenimiento intenta ingresar más tarde"
                );
                cerrarSesion();
              } else {
                showAlert(
                  "No se encontro información en este perido de los elementos seleccionados"
                );
                setGraphReady(true);
                setGridReady(true);
                setDataCSV([]);
              }
            }
          }
        });
      }
    }
  }
  //ver detalle historico
  async function verDetalleHistorico() {
    setIsDetalleHistorico(true);
    await apiCall("POST", "reporte/ventasDetalle", {
      fecha_inicio: "2019-01-01",
      fecha_fin: actualDateRange[1],
      grupo_concepto: concepto.current,
      grupo_tiempo: tiempo.current,
      lista: selectedRowsRecord,
    }).then((res) => {
      if (res.success) {
        setIsDetalle(true);
        setFechaActualizacion(res.data.fecha_actualizacion);
        setDataGraph(res.data.graph);
        setDataTotales({});
        setDataGrid(res.data.grid);
        setDataCSV(generarDataDetalle(res.data.grid));
        setGraphReady(true);
        setGridReady(true);
      } else {
        if (res.code === 401) {
          showAlert("La sesión caducó, por favor ingresa de nuevo");
          cerrarSesion();
        } else {
          if (res.code === 503) {
            showAlert("Estamos en mantenimiento intenta ingresar más tarde");
            cerrarSesion();
          } else {
            showAlert(
              "No se encontro información en este perido de los elementos seleccionados"
            );
            setGraphReady(true);
            setGridReady(true);
            setDataCSV([]);
          }
        }
      }
    });
  }
  //regresar info
  async function regresarDetalle() {
    setDbcDetalle(false);
    setIsDetalle(false);
    setIsDetalleHistorico(false);
    setShowDetalleOptions({ ver: false, regresar: false });
    setGridReady(false);
    setGraphReady(false);
    await apiCall("POST", "reporte/ventas", {
      fecha_inicio: actualDateRange[0],
      fecha_fin: actualDateRange[1],
      grupo_concepto: concepto.current,
      grupo_tiempo: tiempo.current,
      ocultar_nulos: !estadoSwitch ? 1 : 0,
    }).then((res) => {
      if (res.success) {
        setFechaActualizacion(res.data.fecha_actualizacion);
        setDataGraph(res.data.graph);
        setDataTotales(res.data.totales);
        setDataGrid(res.data.grid);
        setDataCSV(generarData(res.data.grid));
        setGraphReady(true);
        setGridReady(true);
      } else {
        if (res.code === 401) {
          showAlert("La sesión caducó, por favor ingresa de nuevo");
          cerrarSesion();
        } else {
          if (res.code === 503) {
            showAlert("Estamos en mantenimiento intenta ingresar más tarde");
            cerrarSesion();
          } else {
            showAlert(
              "No se encontro información en este perido de los elementos seleccionados"
            );
            setDataGraph([]);
            setDataTotales(0);
            setDataGrid([]);
            setDataCSV([]);
            setGraphReady(true);
            setGridReady(true);
          }
        }
      }
    });
  }
  async function toogleMostrarTodo() {
    setGridReady(false);
    if (estadoSwitch) {
      console.log("Mostramos todo");
      await apiCall("POST", "reporte/ventas", {
        fecha_inicio: actualDateRange[0],
        fecha_fin: actualDateRange[1],
        grupo_concepto: concepto.current,
        grupo_tiempo: tiempo.current,
        only: "grid",
        ocultar_nulos: 0,
      }).then((res) => {
        if (res.success) {
          setFechaActualizacion(res.data.fecha_actualizacion);
          setDataTotales(res.data.totales);
          setDataGrid(res.data.grid);
          setDataCSV(generarData(res.data.grid));
          setGridReady(true);
        } else {
          if (res.code === 401) {
            showAlert("La sesión caducó, por favor ingresa de nuevo");
            cerrarSesion();
          } else {
            if (res.code === 503) {
              showAlert("Estamos en mantenimiento intenta ingresar más tarde");
              cerrarSesion();
            } else {
              showAlert(
                "No se encontro información en este perido de los elementos seleccionados"
              );
              setDataTotales(0);
              setDataGrid([]);
              setDataCSV([]);
              setGridReady(true);
            }
          }
        }
      });
    } else {
      console.log("Ocultamos todo");
      await apiCall("POST", "reporte/ventas", {
        fecha_inicio: actualDateRange[0],
        fecha_fin: actualDateRange[1],
        grupo_concepto: concepto.current,
        grupo_tiempo: tiempo.current,
        only: "grid",
        ocultar_nulos: 1,
      }).then((res) => {
        if (res.success) {
          setFechaActualizacion(res.data.fecha_actualizacion);
          setDataTotales(res.data.totales);
          setDataGrid(res.data.grid);
          setDataCSV(generarData(res.data.grid));
          setGridReady(true);
        } else {
          if (res.code === 401) {
            showAlert("La sesión caducó, por favor ingresa de nuevo");
            cerrarSesion();
          } else {
            if (res.code === 503) {
              showAlert("Estamos en mantenimiento intenta ingresar más tarde");
              cerrarSesion();
            } else {
              showAlert(
                "No se encontro información en este perido de los elementos seleccionados"
              );
              setDataTotales(0);
              setDataGrid([]);
              setDataCSV([]);
              setGridReady(true);
            }
          }
        }
      });
    }
  }
  const generarData = (data) => {
    let dat = [];
    dat = CsvVenta(concepto.current, data);
    return dat;
  };
  const generarDataDetalle = (data) => {
    let dat = CsvVenta("dataDetalle", data);
    return dat;
  };
  if (ready) {
    return (
      <Wrapper
        id={"reporte_conceptos_container"}
        style={{
          display: "grid",
          gridTemplateColumns: "100%",
          height: "100%",
          gridTemplateRows: showGraph
            ? "90px auto minmax(1fr 500px)"
            : "90px 1fr",
        }}
      >
        <Header
          isDetalle={isDetalle}
          actualGridConcepto={actualGridConcepto}
          dataCSV={dataCSV}
          concepto={concepto}
          showGraph={showGraph}
          toogleSwitch={toogleSwitch}
          toogleFiltro={setFiltro}
          toogleVista={setActualGraphTiempo}
          toogleConcepto={setActualGridConcepto}
          toogleDateRange={toogleDateRange}
          toogleShowDetalleOptions={setShowDetalleOptions}
          showDetalleOptions={showDetalleOptions}
          verDetalle={verDetalle}
          verDetalleDbc={dbcDetalle}
          toogleDetaleDbc={setDbcDetalle}
          regresarDetalle={regresarDetalle}
          actualSelectedRows={selectedRowsString}
          actualSelectedRowsComplete={selectedRows.current}
          isDetalleHistorico={isDetalleHistorico}
          estadoSwitch={estadoSwitch}
          toogleEstadoSwitch={setEstadoSwitch}
          graphReady={graphReady}
          gridReady={gridReady}
          actualConcepto={actualGridConcepto}
        />

        <GraphContainer
          id="graph_container"
          style={{ display: showGraph ? "" : "none" }}
          ready={graphReady ? "true" : undefined}
        >
          {graphReady ? (
            <Graph
              data={dataGraph}
              grupoTiempo={actualGraphTiempo}
              comparar={comparar}
              dataComparar={dataComparar}
            />
          ) : (
            <Loader />
          )}
        </GraphContainer>
        <div className="reporte_container">
          <Toolbar
            toogleFiltro={setFiltro}
            toogleVista={setActualGraphTiempo}
            toogleConcepto={setActualGridConcepto}
            toogleDateRange={toogleDateRange}
            toogleShowDetalleOptions={setShowDetalleOptions}
            showDetalleOptions={showDetalleOptions}
            verDetalle={verDetalle}
            verDetalleDbc={dbcDetalle}
            toogleDetaleDbc={setDbcDetalle}
            regresarDetalle={regresarDetalle}
            showGraph={showGraph}
            actualSelectedRows={selectedRowsString}
            actualSelectedRowsComplete={selectedRows.current}
            isDetalle={isDetalle}
            isDetalleHistorico={isDetalleHistorico}
            estadoSwitch={estadoSwitch}
            toogleEstadoSwitch={setEstadoSwitch}
            graphReady={graphReady}
            gridReady={gridReady}
            actualConcepto={actualGridConcepto}
            toogleComparar={setComparar}
            toogleDateRangeCompare={toogleDateRangeCompare}
          />
          <GridContainer id="grid_container">
            {/* <FiltroLoading id={'filtro_loading'} style={{display:cargandoMostrar?'':'none'}}><Loader/></FiltroLoading> */}
            <Grid
              ready={gridReady}
              concepto={actualGridConcepto}
              data={dataGrid}
              dataTotales={dataTotales}
              filtro={filtro}
              isDetalle={isDetalle}
              isDetalleHistorico={isDetalleHistorico}
              exportGrid={exportGrid}
              toogleExportGrid={setExportGrid}
              toogleSelected={toogleSelectedRows}
              verDetalle={verDetalle}
              toogleReady={setGridReady}
              fechaActualizacion={fechaActualizacion}
              sideBarCollapsed={props.collapsed} //bandera del menu para escuchar si esta o no colapsado
            />
          </GridContainer>
        </div>
      </Wrapper>
    );
  } else {
    return <Loader />;
  }
}
export default Reporte;
